import { Box, Typography, Button, Avatar } from '@mui/material'
import { keyframes } from '@mui/system'
import { HOME } from '../content/Content'
import React from 'react'
import useNavigation from '../hooks/useNavigation'
import { RoutesPath } from '../constants/RoutesPath'
import { Colors } from '../constants/Colors'

const fadeIn = keyframes`
  0% { opacity: 0; }
  100% { opacity: 1; }
`

const bounce = keyframes`
  0% { transform: scale(1); }
  50% { transform: scale(1.1); }
  100% { transform: scale(1); }
`

const HomePage: React.FC = () => {
   const { navigateTo } = useNavigation()

   return (
      <Box
         sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: 'calc(100vh - 64px)',
            width: '100vw',
            background: `linear-gradient(to right, ${Colors.NAVY_GREEN}, ${Colors.NAVY_BLUE})`,
            animation: `${fadeIn} 2s ease-in`,
            overflowY: 'auto',
         }}
      >
         <Avatar
            alt="me avatar"
            src={HOME.photo}
            sx={{
               width: 220,
               height: 220,
               marginBottom: 3,
               animation: `${bounce} 2s ease-in-out`,
            }}
         />
         <Typography
            variant="h2"
            sx={{
               fontWeight: 'bold',
               fontSize: '4rem',
               color: Colors.WHITE,
               fontFamily: 'Sour Gummy',
               animation: `${fadeIn} 2s ease-in`,
            }}
         >
            {HOME.title}
         </Typography>
         <Typography
            variant="body1"
            sx={{
               fontSize: '1.25rem',
               color: Colors.LIGHT_GRAY,
               marginTop: 2,
               animation: `${fadeIn} 2s ease-in`,
            }}
         >
            {HOME.description}
         </Typography>
         <Button
            variant="contained"
            color="primary"
            sx={{
               marginTop: 3,
               padding: '10px 20px',
               fontSize: '1rem',
               background: Colors.NAVY_BLUE,
               '&:hover': {
                  background: Colors.NAVY_GREEN,
               },
            }}
            onClick={() => navigateTo(RoutesPath.PROJECTS)}
         >
            Projects
         </Button>
      </Box>
   )
}

export default HomePage
